import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import columnToTypeIcon from 'data-frames/util/columnToTypeIcon';
import {FONT_FAMILY_PROXIMA} from 'styles/FontConstants';
import {GRAY_LIGHTER, GRAY_SEMIDARK} from 'ui-library/Colors';
import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ColumnReferenceChipProps {
  column: DataFrameColumnDef | null;
  columnReferenceString: string;
}

export default function ColumnReferenceChip({
  column,
  columnReferenceString,
}: ColumnReferenceChipProps): JSX.Element {
  return column == null ? (
    <span
      className={css(styles.chip, styles.error)}
      contentEditable={false}
      data-original-text={columnReferenceString}
    >
      <BenchlingIcon className={css(styles.icon, styles.error)} icon="exclamation-circle" />
      Missing
    </span>
  ) : (
    <span className={css(styles.chip)} contentEditable={false} data-original-text={columnReferenceString}>
      <BenchlingIcon className={css(styles.icon)} icon={columnToTypeIcon(column)} />
      {column.displayName}
    </span>
  );
}

export function getColumnReferenceChipHTML(
  columnReferenceString: string,
  column: DataFrameColumnDef | null
): string {
  return ReactDOMServer.renderToStaticMarkup(
    <ColumnReferenceChip column={column} columnReferenceString={columnReferenceString} />
  );
}

const styles = StyleSheet.create({
  chip: {
    borderRadius: 4,
    backgroundColor: GRAY_LIGHTER,
    padding: '2px 8px',
    userSelect: 'none',
    // The editor changes the font for regular text, so we need to change it back here
    fontFamily: FONT_FAMILY_PROXIMA,
    fontSize: 15,
  },
  error: {
    color: Colors.RED_DARK,
    backgroundColor: Colors.RED_LIGHTEST,
  },
  icon: {
    color: GRAY_SEMIDARK,
    marginRight: 5,
  },
});
